<template>
  <v-autocomplete
      :items="items"
      item-value="id"
      item-text="name"
      no-data-text="Žiadne výsledky"
      :loading="loading"
      :disabled="loading"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template
        v-slot:append-outer
    >
      <CreateVolunteer
          v-if="createButton"
          :icon="true"
          :small="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :small="true"
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
  import Volunteers from '@/services/volunteers'

  import CreateVolunteer from '@/components/Volunteers/Create'

  export default {
    name: 'Suggest',
    props: [
      'support',
      'createButton'
    ],
    components: {
      CreateVolunteer
    },
    data() {
      return {
        loading: false,
        volunteers: []
      }
    },
    mounted() {
      this.init()
    },
    computed: {
      items() {
        return (
          typeof this.support === 'function'
            ? this.support(this.volunteers)
            : this.volunteers
        )
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      loadData() {
        this.loading = true

        Volunteers
          .suggest()
          .then((response) => {
            this.volunteers = response.data.data.volunteers
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
